import {PermissionsMap} from './permissions-map.type';

export interface DefaultPermission {
    id: number;
    faName: string;
    enName: string;
    permissionGroupType: string;
    permissionSectionType: string;
    faDescription: string;
    enDescription: string;
    inActive: boolean;
    isChecked?: boolean;
}


export class DefaultPermissions {
    private _permissions;
    private _assetPermissions;

    constructor() {
        this._permissions = new Array<DefaultPermission>();
        this._permissions = [
            {
            id: 1,
            permissionGroupType: 'Workspace',
            permissionSectionType: 'None',
            faName: 'مشاهده',
            enName: 'View',
            faDescription: '',
            enDescription: '',
            inActive: false,
          },
          {
            id: 2,
            permissionGroupType: 'Workspace',
            permissionSectionType: 'None',
            faName: 'ویرایش',
            enName: 'Edit',
            faDescription: '',
            enDescription: '',
            inActive: false,
          },
          {
            id: 3,
            permissionGroupType: 'Workspace',
            permissionSectionType: 'None',
            faName: 'دسترسی های',
            enName: 'Permissions',
            faDescription: '',
            enDescription: '',
            inActive: false,
          },
          {
            id: 4,
            permissionGroupType: 'Workspace',
            permissionSectionType: 'None',
            faName: 'گروه کاربران',
            enName: 'UserGroup',
            faDescription: '',
            enDescription: '',
            inActive: false,
          },
          {
            id: 5,
            permissionGroupType: 'Workspace',
            permissionSectionType: 'None',
            faName: 'ساخت داشبورد',
            enName: 'CreateDashboard',
            faDescription: '',
            enDescription: '',
            inActive: false,
          },
          {
            id: 6,
            permissionGroupType: 'Workspace',
            permissionSectionType: 'None',
            faName: 'ساخت منبع داده',
            enName: 'CreateDataSource',
            faDescription: '',
            enDescription: '',
            inActive: false,
          },
          {
            id: 7,
            permissionGroupType: 'Workspace',
            permissionSectionType: 'None',
            faName: 'مدیریت کابران',
            enName: 'UserManagement',
            faDescription: '',
            enDescription: '',
            inActive: false,
          },
          {
            id: 8,
            permissionGroupType: 'Workspace',
            permissionSectionType: 'None',
            faName: 'مشاهده تاریخچه تغییرات',
            enName: 'ViewHistoryChange',
            faDescription: '',
            enDescription: '',
            inActive: false,
          },
          {
            id: 9,
            permissionGroupType: 'Workspace',
            permissionSectionType: 'None',
            faName: 'مشاهده همه ارتباطات',
            enName: 'ViewDataSourceRelation',
            faDescription: '',
            enDescription: '',
            inActive: false,
          },
          {
            id: 100,
            permissionGroupType: 'DashboardGroup',
            permissionSectionType: 'None',
            faName: 'مشاهده',
            enName: 'View',
            faDescription: '',
            enDescription: '',
            inActive: false,
          },
          {
            id: 101,
            permissionGroupType: 'DashboardGroup',
            permissionSectionType: 'None',
            faName: 'ویرایش',
            enName: 'Edit',
            faDescription: '',
            enDescription: '',
            inActive: false,
          },
          {
            id: 102,
            permissionGroupType: 'DashboardGroup',
            permissionSectionType: 'None',
            faName: 'اضافه/حذف داشبورد',
            enName: 'Movement',
            faDescription: '',
            enDescription: '',
            inActive: false,
          },
          {
            id: 103,
            permissionGroupType: 'DashboardGroup',
            permissionSectionType: 'None',
            faName: 'دسترسی ها',
            enName: 'Permissions',
            faDescription: '',
            enDescription: '',
            inActive: false,
          },
          {
            id: 104,
            permissionGroupType: 'DashboardGroup',
            permissionSectionType: 'None',
            faName: 'حذف',
            enName: 'Remove',
            faDescription: '',
            enDescription: '',
            inActive: false,
          },
          {
            id: 200,
            permissionGroupType: 'Dashboard',
            permissionSectionType: 'None',
            faName: 'مشاهده',
            enName: 'View',
            faDescription: '',
            enDescription: '',
            inActive: false,
          },
          {
            id: 201,
            permissionGroupType: 'Dashboard',
            permissionSectionType: 'None',
            faName: 'مشاهده نظرات',
            enName: 'ViewComment',
            faDescription: '',
            enDescription: '',
            inActive: false,
          },
          {
            id: 202,
            permissionGroupType: 'Dashboard',
            permissionSectionType: 'None',
            faName: 'اضافه کردن نظر',
            enName: 'WriteComment',
            faDescription: '',
            enDescription: '',
            inActive: false,
          },
          {
            id: 203,
            permissionGroupType: 'Dashboard',
            permissionSectionType: 'None',
            faName: 'حل نظر',
            enName: 'ResolveComment',
            faDescription: '',
            enDescription: '',
            inActive: false,
          },
          {
            id: 204,
            permissionGroupType: 'Dashboard',
            permissionSectionType: 'None',
            faName: 'اضافه کردن نمودار',
            enName: 'AddChart',
            faDescription: '',
            enDescription: '',
            inActive: false,
          },
          {
            id: 205,
            permissionGroupType: 'Dashboard',
            permissionSectionType: 'None',
            faName: 'ویرایش',
            enName: 'Edit',
            faDescription: '',
            enDescription: '',
            inActive: false,
          },
          {
            id: 206,
            permissionGroupType: 'Dashboard',
            permissionSectionType: 'None',
            faName: 'انتقال',
            enName: 'Movement',
            faDescription: '',
            enDescription: '',
            inActive: true,
          },
          {
            id: 207,
            permissionGroupType: 'Dashboard',
            permissionSectionType: 'None',
            faName: 'فعال/غیر فعال',
            enName: 'Activate/Deactivate',
            faDescription: '',
            enDescription: '',
            inActive: false,
          },
          {
            id: 208,
            permissionGroupType: 'Dashboard',
            permissionSectionType: 'None',
            faName: 'دسترسی ها',
            enName: 'Permissions',
            faDescription: '',
            enDescription: '',
            inActive: false,
          },
          {
            id: 209,
            permissionGroupType: 'Dashboard',
            permissionSectionType: 'None',
            faName: 'حذف',
            enName: 'Remove',
            faDescription: '',
            enDescription: '',
            inActive: false,
          },
          {
            id: 210,
            permissionGroupType: 'Dashboard',
            permissionSectionType: 'None',
            faName: 'اشتراک گذاری',
            enName: 'Share',
            faDescription: '',
            enDescription: '',
            inActive: false,
          },
          {
            id: 211,
            permissionGroupType: 'Dashboard',
            permissionSectionType: 'None',
            faName: 'متغیر کاربری',
            enName: 'UserFilter',
            faDescription: '',
            enDescription: '',
            inActive: false,
          },
          {
            id: 300,
            permissionGroupType: 'DataSourceGroup',
            permissionSectionType: 'None',
            faName: 'اجازه های گروه منبع داده',
            enName: 'DataSourceGroupPermissions',
            faDescription: '',
            enDescription: '',
            inActive: false,
          },
          {
            id: 400,
            permissionGroupType: 'DataSource',
            permissionSectionType: 'None',
            faName: 'مشاهده',
            enName: 'View',
            faDescription: '',
            enDescription: '',
            inActive: false,
          },
          {
            id: 401,
            permissionGroupType: 'DataSource',
            permissionSectionType: 'None',
            faName: 'ارتباطات',
            enName: 'Relations',
            faDescription: '',
            enDescription: '',
            inActive: false,
          },
          {
            id: 402,
            permissionGroupType: 'DataSource',
            permissionSectionType: 'None',
            faName: 'ویرایش',
            enName: 'Edit',
            faDescription: '',
            enDescription: '',
            inActive: false,
          },
          {
            id: 403,
            permissionGroupType: 'DataSource',
            permissionSectionType: 'None',
            faName: 'مشاهده زمان‌بندی',
            enName: 'ViewSchedule',
            faDescription: '',
            enDescription: '',
            inActive: false,
          },
          {
            id: 404,
            permissionGroupType: 'DataSource',
            permissionSectionType: 'None',
            faName: 'ویرایش',
            enName: 'EditSchedule',
            faDescription: '',
            enDescription: '',
            inActive: false,
          },
          {
            id: 405,
            permissionGroupType: 'DataSource',
            permissionSectionType: 'None',
            faName: 'مشاهده تاریخچه تغییرات',
            enName: 'ViewHistoryChange',
            faDescription: '',
            enDescription: '',
            inActive: false,
          },
          {
            id: 406,
            permissionGroupType: 'DataSource',
            permissionSectionType: 'None',
            faName: 'دسترسیی ها',
            enName: 'Permissions',
            faDescription: '',
            enDescription: '',
            inActive: false,
          },
          {
            id: 407,
            permissionGroupType: 'DataSource',
            permissionSectionType: 'None',
            faName: 'حذف',
            enName: 'Remove',
            faDescription: '',
            enDescription: '',
            inActive: false,
          },
          {
            id: 408,
            permissionGroupType: 'DataSource',
            permissionSectionType: 'None',
            faName: 'متغیر کاربری',
            enName: 'UserFilter',
            faDescription: '',
            enDescription: '',
            inActive: false,
          },
          {
            id: 500,
            permissionGroupType: 'Chart',
            permissionSectionType: 'None',
            faName: 'مشاهده',
            enName: 'View',
            faDescription: '',
            enDescription: '',
            inActive: false,
          },
          {
            id: 501,
            permissionGroupType: 'Chart',
            permissionSectionType: 'None',
            faName: 'ویرایش',
            enName: 'Edit',
            faDescription: '',
            enDescription: '',
            inActive: false,
          },
          {
            id: 502,
            permissionGroupType: 'Chart',
            permissionSectionType: 'None',
            faName: 'فیلتر کاربری',
            enName: 'UserFilter',
            faDescription: '',
            enDescription: '',
            inActive: false,
          },
          {
            id: 503,
            permissionGroupType: 'Chart',
            permissionSectionType: 'None',
            faName: 'خروجی',
            enName: 'Export',
            faDescription: '',
            enDescription: '',
            inActive: false,
          },
          {
            id: 504,
            permissionGroupType: 'Chart',
            permissionSectionType: 'None',
            faName: 'دسترسی ها',
            enName: 'Permissions',
            faDescription: '',
            enDescription: '',
            inActive: false,
          },
          {
            id: 505,
            permissionGroupType: 'Chart',
            permissionSectionType: 'None',
            faName: 'حذف',
            enName: 'Remove',
            faDescription: '',
            enDescription: '',
            inActive: false,
          },
        ];
    }

    public get permissions() {
        return this._permissions;
    }

    public contains(id: number): boolean {
        return !!this._assetPermissions.find(permission => permission.id === id);
    }

    public filter(permissionGroupType: string): Map<string, {id: string;isChecked: boolean}> {
      const result = new Map<string, {id: string;isChecked: boolean}>();
      const currentPermissions =
      this._permissions.filter(permission => permission.permissionGroupType === permissionGroupType);
      currentPermissions.forEach(permission =>
        result.set(permission.enName,{id: permission.id,isChecked: false}));
      return result;
    }

    public findPermissions(permissions: number[],id: number): boolean {
        this._assetPermissions = new Array<DefaultPermission>();
        if(permissions !== null) {
            permissions.forEach(permission => {
                this._assetPermissions.push(this._permissions.find(tempPermisson => tempPermisson.id === permission));
            });
        } else {
            this._assetPermissions = this._permissions;
        }
        return this.contains(id);
    }

    public mapPermissions(permissions: any[]): Map<string, {id: string;isChecked: boolean}> {
      const result = new Map<string, {id: string;isChecked: boolean}>();
      this._permissions.forEach(permission => {
        let isExistPermission = false;
        for(let index = 0; index < permissions.length; index++) {
          if(permission.id === permissions[index]) {
            permission.isChecked = true;
            isExistPermission = true;
            result.
            set(permission.permissionGroupType + '*' + permission.enName,
            {id: permission.id,isChecked:permission.isChecked});
            break;
          }
        }
        if(!isExistPermission) {
          permission.isChecked = false;
          result.
          set(permission.permissionGroupType + '*' + permission.enName,
          {id: permission.id,isChecked:permission.isChecked});
        }
      });

      return result;
    }

    public mapSpecificPermissions(permissions: any[],
                                  permissionGroupType: string,
                                  permissionBlocked: boolean,
                                  isSuperAdmin: boolean = false): PermissionsMap {
      const result = new Map<string, {id: string;isChecked: boolean}>();
      permissions = permissions !== undefined && permissions !== null ? permissions : [];
      this._permissions.forEach(permission => {
        let isExistPermission = false;
        for(let index = 0; index < permissions.length; index++) {
          if(permission.id === permissions[index] && permission.permissionGroupType === permissionGroupType) {
            permission.isChecked = !permissionBlocked || isSuperAdmin;
            isExistPermission = true;
            result.set(permission.enName, {id: permission.id,isChecked:permission.isChecked});
            break;
          }
        }
        if(!isExistPermission && permission.permissionGroupType === permissionGroupType) {
          permission.isChecked = permissionBlocked || isSuperAdmin;
          result.set(permission.enName, {id: permission.id,isChecked:permission.isChecked});
        }
      });
      return result;
    }
    public addExtraInfo(): any {
      const result = new Map<any, any>();
      this._permissions.forEach(permission => {
        permission.isChecked = false;
        result.set(permission.permissionGroupType + '*' + permission.enName,
        {id: permission.id,isChecked:permission.isChecked});
      });
      return result;
    }
}
